<template>
	<!-- Subscription Box -->
	<div class="row subscription-box">
		<div class="col p-4 text-left d-flex flex-column justify-content-between">
			<!-- Logo Section -->
			<div class="logo-container">
				<img :src="appLogo" :alt="appName">
			</div>
			<!-- End Logo Section -->

			<!-- Benefit Section -->
			<div class="benefit-section">
				<div class="benefit-title">Benefit Join OStock :</div>
				<div class="benefit-content" v-if="benefitList">
					<div class="benefit-item" v-for="(benefit, idx) in benefitList" :key="idx">
						<span class="material-icons benefit-icon">task_alt</span>
						<span class="benefit-text">{{ benefit }}</span>
					</div>
				</div>
			</div>
			<!-- End Benefit Section -->

			<!-- Subscription Section -->
			<div class="subscription-detail">
				<div class="row mb-4">
					<div class="col"><b>Rincian Pesanan</b></div>
				</div>

				<div class="row mb-4">
					<div class="col">Pendaftaran Seller Ostock</div>
					<div class="col-auto text-success"><b>Gratis</b></div>
				</div>

				<!-- Dashed Line -->
				<div class="mb-2">
					<svg width="100%" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg">
						<line stroke-dasharray="10, 5" x1="0" y1="10" x2="1000" y2="10" style="stroke: rgb(196, 198, 203);">
						</line>
					</svg>
					<div class="round round-left"></div>
					<div class="round round-right"></div>
				</div>
				<!-- End Dashed Line -->

				<div class="row">
					<div class="col"><b>Total</b></div>
					<div class="col-auto text-success"><b>Gratis</b></div>
				</div>
			</div>
			<!-- End Subscription Section -->
		</div>
	</div>
	<!-- End Subscription Box -->
</template>

<script>
export default {
	name: 'SubscriptionBox',
	props: {
		appName: {
			type: String,
			default: 'Ostock',
		},
	},
	data() {
		return {
			benefitList: [
				'PENDAFTARAN GRATIS',
				'1500+ PRODUK BISA DI JUAL TANPA MODAL',
				'COD READY SE-INDONESIA',
				'GRATIS LIST PRODUK-PRODUK WINNING',
				'GRATIS MARKETING KIT DAN LANDING PAGE SETIAP PRODUK',
			],
			appLogo: process.env.VUE_APP_LOGO,
		};
	},
};
</script>

<style lang="scss" scoped>
.subscription-box {
	background-color: #F6F6F6;
	width: 100%;
	margin-left: 0;
	margin-right: 0;
	padding-bottom: 0.5rem !important;
}

.subscription-detail {
	border-radius: 8px;
	background-color: white !important;
	padding: 1.5rem !important;
	color: black !important;
	position: relative;
}

.logo-container {
	width: 210px;
	padding-top: 2rem !important;
	padding-bottom: 2rem !important;

	img {
		max-width: 100%;
		height: auto;
	}

	@media (max-width: 575px) {
		margin: 0 auto;
	}

}

.benefit-section {
	margin-bottom: 1.5rem !important;
}

.benefit-title {
	font-size: 20px;
	font-weight: 600;
	color: black;
}

.benefit-content {
	margin-top: 1rem;
}

.benefit-item {
	display: flex !important;
	margin-bottom: 0.5rem !important;
	align-items: center !important;

	@media (max-width: 575px) {
		align-items: start !important;
	}
}

.benefit-icon {
	color: #F28900;
	margin-right: 0.5rem !important;
}

.benefit-text {
	font-size: 14px;
	font-weight: 400;
	color: #004D8D;
}

.round {
	position: absolute;
	width: 30px;
	height: 30px;
	background-color: #F6F6F6;
	border-radius: 50%;
	margin-top: -25px;

	&-left {
		left: -15px;
	}

	&-right {
		right: -15px;
	}
}

line {
	stroke: rgb(196, 198, 203);
	stroke-width: 2
}
</style>
